import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@features/ui';
import { LogoutIcon } from '@features/ui/icons';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useAuth } from '@hooks/useAuth.ts';

import { NavItem } from '../navItem';
import { NavItemWithSub } from '../navItemWithSub';

import { getAdminSidebarData } from './adminSidebarData';

export function AdminSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const { t } = useTranslation();
  const { logout, me } = useAuth();
  const sidebarData = getAdminSidebarData(me?.permissions);

  const visibleNavItems = sidebarData.navItems.filter((item) => !item.disabled);

  return (
    <Sidebar collapsible="icon" variant="floating" {...props}>
      <SidebarHeader className="mb-8 pl-7 pt-12">
        <img alt="logo" height={42} src="/assets/logo.svg" width={160} />
      </SidebarHeader>
      <SidebarContent>
        <SidebarMenu>
          {visibleNavItems.map((item, index) =>
            item.items && item.items.length > 0 ? (
              <NavItemWithSub key={`${props.title}_${index}`} item={item} />
            ) : (
              <NavItem key={`${props.title}_${index}`} item={item} />
            )
          )}
          <SidebarMenuItem>
            <div className="flex gap-x-5 pr-2 md:pr-0">
              <div className="w-1 rounded-tr-[4px] rounded-br-[4px]" />
              <SidebarMenuButton asChild className="h-[50px] gap-x-[18px]">
                <button className={'cursor-pointer'} onClick={logout}>
                  <LogoutIcon />
                  <span>{t('dashboardMenuItems.logout')}</span>
                </button>
              </SidebarMenuButton>
            </div>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarContent>
    </Sidebar>
  );
}
